import React from 'react'
import PropTypes from 'prop-types'
import ProjectReturnLink from '../../../components/ProjectReturnLink'
import BoardSelector from '../../../components/BoardSelector'
import BoardInfo from '../../../components/BoardInfo'
import BoardFilterButton from '../../../components/BoardFilterButton'
import './BoardHeader.scss'

const BoardHeader = (props) => {
  return (
    <div className='board-header'>
      <div className='board-header-left'>
        <ProjectReturnLink className='header-project-return-link' />
      </div>
      <div className='board-header-center'><span>{props.project.name}</span></div>
      <div className='board-header-right'>
        { props.project.actions.setBoard &&
          <BoardSelector className='board-header-board-selector' />
        }
        <BoardFilterButton />
        <BoardInfo className='board-header-help' />
      </div>
    </div>
  )
}

BoardHeader.propTypes = {
  project: PropTypes.object
}

export default BoardHeader



// WEBPACK FOOTER //
// ./src/routes/Board/components/BoardHeader.js